import { CALL_API } from '../middleware/api'

// Fetch all SLAs
export const SLAS_REQUEST = 'SLAS_REQUEST'
export const SLAS_SUCCESS = 'SLAS_SUCCESS'
export const SLAS_FAILURE = 'SLAS_FAILURE'

export function fetchSLAs() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'slas',
      authenticated: true,
      types: [SLAS_REQUEST, SLAS_SUCCESS, SLAS_FAILURE]
    }
  }
}

// Fetch single SLA
export const SLA_REQUEST = 'SLA_REQUEST'
export const SLA_SUCCESS = 'SLA_SUCCESS'
export const SLA_FAILURE = 'SLA_FAILURE'

export function fetchSLA(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `slas/${id}`,
      authenticated: true,
      types: [SLA_REQUEST, SLA_SUCCESS, SLA_FAILURE]
    }
  }
}

// Add SLA
export const SLA_ADD_REQUEST = 'SLA_ADD_REQUEST'
export const SLA_ADD_SUCCESS = 'SLA_ADD_SUCCESS'
export const SLA_ADD_FAILURE = 'SLA_ADD_FAILURE'

export function addSLA(sla) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'slas',
      authenticated: true,
      body: JSON.stringify(sla),
      types: [SLA_ADD_REQUEST, SLA_ADD_SUCCESS, SLA_ADD_FAILURE]
    }
  }
}

// Update SLA
export const SLA_UPDATE_REQUEST = 'SLA_UPDATE_REQUEST'
export const SLA_UPDATE_SUCCESS = 'SLA_UPDATE_SUCCESS'
export const SLA_UPDATE_FAILURE = 'SLA_UPDATE_FAILURE'

export function updateSLA(id, sla) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `slas/${id}`,
      authenticated: true,
      body: JSON.stringify(sla),
      types: [SLA_UPDATE_REQUEST, SLA_UPDATE_SUCCESS, SLA_UPDATE_FAILURE]
    }
  }
}

// Delete SLA
export const SLA_DELETE_REQUEST = 'SLA_DELETE_REQUEST'
export const SLA_DELETE_SUCCESS = 'SLA_DELETE_SUCCESS'
export const SLA_DELETE_FAILURE = 'SLA_DELETE_FAILURE'

export function deleteSLA(id) {
  return {
    [CALL_API]: {
      method: 'DELETE',
      endpoint: `slas/${id}`,
      authenticated: true,
      types: [SLA_DELETE_REQUEST, SLA_DELETE_SUCCESS, SLA_DELETE_FAILURE]
    }
  }
}
